
import { useLanguage } from "@/contexts/LanguageContext";
import { Label } from "@/components/ui/label";
import DayBasedUpload from "./DayBasedUpload";
import type { Creative, Location } from "../../types";

interface LocationCreativeItemProps {
  location: Location;
  creatives: Creative[];
  onLocationFileChange: (locationName: string, e: React.ChangeEvent<HTMLInputElement>, day?: number) => void;
  onRemoveLocationCreative: (locationName: string, index: number) => void;
  onUpdateCreativeDays?: (locationName: string, creativeIndex: number, days: number[]) => void;
  isUploading: boolean;
}

const LocationCreativeItem = ({
  location,
  creatives,
  onLocationFileChange,
  onRemoveLocationCreative,
  onUpdateCreativeDays,
  isUploading
}: LocationCreativeItemProps) => {
  return (
    <div className="space-y-2">
      <Label className="text-sm font-medium">{location.name}</Label>
      <DayBasedUpload
        locationName={location.name}
        creatives={creatives}
        onFileChange={onLocationFileChange}
        onRemoveCreative={onRemoveLocationCreative}
        onUpdateCreativeDays={onUpdateCreativeDays}
        isUploading={isUploading}
      />
    </div>
  );
};

export default LocationCreativeItem;
